"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SideItem = _interopRequireDefault(require("./SideItem.js"));

var _styled = require("../styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavProductList = function NavProductList(props) {
  var products = props.products,
      current = props.current;
  var otherProducts = products.filter(function (item) {
    return item !== current;
  });

  if (products.length === 1) {
    return null;
  }

  var ccIndex = otherProducts.indexOf('content_catalogue');

  if (ccIndex !== -1) {
    otherProducts.splice(ccIndex, 1, 'infinite');
  }

  var wsIndex = otherProducts.indexOf('wisdom_stream');

  if (wsIndex !== -1 && !otherProducts.includes('infinite')) {
    otherProducts.splice(wsIndex, 1, 'infinite');
  }

  return _react["default"].createElement(_styled.StyledProductList, null, otherProducts.map(function (product) {
    return _react["default"].createElement(_SideItem["default"], {
      Component: "a",
      key: "sideItem_".concat(product),
      url: "/".concat(product),
      name: product
    });
  }));
};

var _default = NavProductList;
exports["default"] = _default;

//# sourceMappingURL=NavProductList.js.map